import { Inject, Injectable } from '@angular/core';
import {
  CategoryL1,
  CategoryL2,
  Event_Action,
  Event_Category,
  Event_Label,
  Event_Name,
  Event_PageGroup,
  UDO,
} from '../global';
import { TealiumService } from './tealium.service';

@Injectable({
  providedIn: 'root',
})
export class FormInfoService {
  constructor(private _tealium: TealiumService) {}
  pageLoad(vehicles: any, zipCode: string) {
    try {
      const pageLoad: any = {};

      const enhImpressionIdArray = vehicles.map((item) => {
        return item['Vin'];
      });

      const enhImpressionPositionArray = vehicles.map((x, i: number) => i);

      let maxmindData = null;
      try {
        maxmindData = sessionStorage.getItem('maxmind') ? JSON.parse(sessionStorage.getItem('maxmind')) : null;
      } catch(e) {}

      console.log('maxmindData - ', maxmindData);

      pageLoad.category_l1 = CategoryL1.myAccount;
      pageLoad.category_l2 = CategoryL2.myFavorites;
      pageLoad.category_l3 = UDO.NotSet;
      pageLoad.category_l4 = UDO.NotSet;
      pageLoad.vehicle_results_count = vehicles.length;
      pageLoad.results_per_page = vehicles.length;
      pageLoad.results_page = 1;
      pageLoad.zipcode = zipCode;
      pageLoad.enh_impression_id = enhImpressionIdArray;
      pageLoad.enh_impression_position = enhImpressionPositionArray;
      pageLoad.number_content_result = vehicles.length;

      // pageLoad.ip_address = UDO.NotSet;
      // pageLoad.latitude = '';
      // pageLoad.longitude = '';

      pageLoad.ip_address =
        maxmindData && maxmindData['maxmind_traits.ip_address']
          ? maxmindData['maxmind_traits.ip_address']
          : UDO.NotSet;
      pageLoad.latitude =
        maxmindData && maxmindData['maxmind_location.latitude']
          ? maxmindData['maxmind_location.latitude']
          : UDO.NotSet;
      pageLoad.longitude =
        maxmindData && maxmindData['maxmind_location.longitude']
          ? maxmindData['maxmind_location.longitude']
          : UDO.NotSet;

      console.log('pageLoad - ', pageLoad);

      (window as any).utag_data = pageLoad;
      this._tealium.view((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  private tealiumLinkCall(eventName: string, eventlabel: string) {
    try {
      const pageLoad: any = {};
      pageLoad.category_l1 = CategoryL1.myAccount;
      pageLoad.category_l2 = CategoryL2.myFavorites;
      pageLoad.category_l3 = UDO.NotSet;
      pageLoad.category_l4 = UDO.NotSet;
      pageLoad.event = eventName;
      pageLoad.event_category = Event_Category.UserActivityType;
      pageLoad.event_action = Event_Action.UserActivityType_MyAccount_Click;
      pageLoad.event_label = eventlabel;
      pageLoad.event_value = 1;
      pageLoad.pagegroup = Event_PageGroup.My_Account;
      (window as any).utag_data = pageLoad;
      this._tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  heartLinkCall() {
    this.tealiumLinkCall(Event_Name.UnsaveVehicle, Event_Label.UnsaveVehicle);
  }

  shopInventoryLinkCall() {
    this.tealiumLinkCall(Event_Name.ShopInventory, Event_Label.ShopInventory);
  }

  shopMoreInventoryLinkCall() {
    this.tealiumLinkCall(
      Event_Name.ShopMoreInventory,
      Event_Label.ShopMoreInventory
    );
  }

  shopNowZeroStateLinkCall() {
    this.tealiumLinkCall(
      Event_Name.ShopMoreInventory,
      Event_Label.ShopMoreInventory
    );
  }

  vehicleClickLinkCall(vehicleName: string) {
    this.tealiumLinkCall(Event_Name.VehicleClick, vehicleName);
  }

  favoriteRemovalUndo() {
    this.tealiumLinkCall(
      Event_Name.UndoRemovedFromFavorites,
      Event_Label.UndoRemovedFromFavorites
    );
  }

  subNavMenuClick(actionLabel) {
    let eventName;
    if(actionLabel === "My Garage") {
      eventName = Event_Label.MyGarage
    } else {
      eventName = actionLabel;
    }
    try {
      const subMenuNavClickCall = {
        category_l1: CategoryL1.myAccount,
        category_l2: CategoryL2.SubNavMenu,
        category_l3: UDO.NotSet,
        category_l4: UDO.NotSet,
        event: Event_Name.SubNavMenu,
        event_category: Event_Category.engagementType,
        event_action: Event_Action.subNavType,
        event_label: eventName,
        event_value: 1,
        pagegroup: Event_PageGroup.My_Account,
      };

      (window as any).utag_data = subMenuNavClickCall;
      this._tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }
}
